import React from "react";
import { FormGroup } from "../../exports";
export function createControlContext() {
  return React.createContext({
    status: "",
    control: new FormGroup({}),
    errors: null,
    validationStatus: undefined,
    validationErrors: undefined
  });
}
export const ControlContext = createControlContext();
export const useControlContext = () => {
  return React.useContext(ControlContext);
};